// Condition icon — a stem forking into two prongs with a bubble at each tip.
// Same fork concept as the original; tweaked for better balance and a subtle
// open circle at the junction so the decision point reads more clearly.
export default function ConditionIcon({ size = 14, color = "currentColor", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Stem going down (a tiny bit shorter than before) */}
      <line x1="8" y1="15" x2="8" y2="10" />
      {/* Hollow junction node */}
      <circle cx="8" cy="10" r="1.5" />
      {/* Two prongs up-and-out, slightly wider spread */}
      <line x1="7" y1="9" x2="3" y2="4" />
      <line x1="9" y1="9" x2="13" y2="4" />
      {/* Filled bubbles at the tips */}
      <circle cx="3" cy="3" r="1.6" fill={color} stroke="none" />
      <circle cx="13" cy="3" r="1.6" fill={color} stroke="none" />
    </svg>
  );
}
